module.exports = __webpack_public_path__ + "static/media/W18-0468_AW_mobile_hero_egger_en.ac9555d6.jpg";